import React, { useEffect, useRef } from "react";
import Particles from "react-tsparticles";

function Particle() {
  const containerRef = useRef(null);

  useEffect(() => {
    let animationFrameId;

    const updateAbsorber = () => {
      const container = containerRef.current;
      if (container) {
        const mousePos = container.interactivity.mouse.position;
        const absPlugin = container.plugins.get("absorbers");
        if (absPlugin && absPlugin.array && absPlugin.array.length > 0) {
          const absorber = absPlugin.array[0];
          if (absorber) {
            if (mousePos) {
              absorber.position.x = mousePos.x;
              absorber.position.y = mousePos.y;
            } else {
              // Move the absorber off-screen when mouse leaves
              absorber.position.x = -9999;
              absorber.position.y = -9999;
            }
          }
        }
      }
      animationFrameId = requestAnimationFrame(updateAbsorber);
    };

    animationFrameId = requestAnimationFrame(updateAbsorber);

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <Particles
      id="tsparticles"
      loaded={(container) => {
        containerRef.current = container;
        window.ptsContainer = container; // Keep for developer console access
      }}
      params={{
        particles: {
          number: {
            value: 100, // Increased star count for a slightly denser starfield
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: ["#ffffff", "#e0aaff", "#c770f0", "#9b5de5"], // Cosmic purple, violet and white stars
          },
          shape: {
            type: "circle",
          },
          opacity: {
            value: 0.5,
            random: true,
            anim: {
              enable: false, // Steady stars
            },
          },
          size: {
            value: 1.8, // Slightly smaller stars for a realistic starry sky
            random: true,
            anim: {
              enable: false,
            },
          },
          line_linked: {
            enable: false, // Clean starfield view
          },
          move: {
            enable: true,
            speed: 0.15, // Extremely slow drifting for a peaceful deep space effect
            direction: "none",
            random: true,
            straight: false,
            out_mode: "out",
            bounce: false,
            deviceOrientation: {
              enable: true, // Enables mobile gyroscope/tilt interaction
              fallback: true,
            },
          },
          twinkle: {
            particles: {
              enable: false, // Twinkle disabled
            },
          },
        },
        interactivity: {
          detect_on: "window",
          events: {
            onhover: {
              enable: true,
              mode: ["attract", "bubble"], // Gravity + Event Horizon Fade
              parallax: {
                enable: true, // 3D parallax scroll/tilt
                force: 25,
                smooth: 12,
              },
            },
            onclick: {
              enable: true,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            attract: {
              distance: 240, // Gravity pull radius
              duration: 0.4,
              speed: 5, // Snappy gravity pull strength
            },
            bubble: {
              distance: 100, // Fades out stars smoothly as they get closer than 100px (ensuring near-zero visibility at absorption threshold)
              size: 0.01, // Shrinks to near-zero (invisible)
              opacity: 0.0001, // Opacity reduces to near-zero (avoiding tsParticles 0-opacity bug)
              duration: 0.3,
            },
            push: {
              particles_nb: 2, // Spawns new stars on click
            },
          },
        },
        absorbers: {
          destroy: false, // Prevents permanent deletion, triggers random respawning at bounds
          opacity: 0, // Makes the mouse-following absorber completely invisible
          size: {
            value: 15, // Larger absorption radius (essential to satisfy 'distance < size - particleRadius' condition)
            limit: 15,
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;
